import { ChangeEvent, FC } from 'react';

import { VideoRoiCalculatorFieldProps } from './videoRoiCalculatorTypes';

const VideoRoiCalculatorRangeField: FC<VideoRoiCalculatorFieldProps> = ({
  title,
  value,
  onChange,
  id,
  name,
  min,
  max,
  placeholder,
  unitSuffix,
}) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    onChange(newValue);
  };

  return (
    <>
      <label htmlFor={id} className="mb-2 mt-3 block text-lg font-bold">
        {title} {unitSuffix && <span>{unitSuffix}</span>}
      </label>

      <span className="inline-block min-w-9 rounded-full bg-green-700 text-center leading-9 text-white">
        {value}
      </span>

      <input
        type="range"
        id={id}
        name={name}
        min={min}
        max={max}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        className="mt-2 w-full cursor-pointer"
      />
    </>
  );
};
export default VideoRoiCalculatorRangeField;
